// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var DetectBrowser = require("detect-browser");
var EdgeSvg = require("./images/edge.svg");
var JsxRuntime = require("react/jsx-runtime");
var ChromeSvg = require("./images/chrome.svg");
var SafariSvg = require("./images/safari.svg");
var FirefoxSvg = require("./images/firefox.svg");

var chrome = ChromeSvg;

var safari = SafariSvg;

var firefox = FirefoxSvg;

var edge = EdgeSvg;

var Icons = {
  chrome: chrome,
  safari: safari,
  firefox: firefox,
  edge: edge
};

var DetectBrowser$1 = {};

var browsers = [
  {
    title: "Google Chrome",
    icon: chrome,
    url: "https://www.google.com/chrome/"
  },
  {
    title: "Apple Safari",
    icon: safari,
    url: "https://www.apple.com/safari/"
  },
  {
    title: "Mozilla Firefox",
    icon: firefox,
    url: "https://www.mozilla.org/en-US/firefox/new/"
  },
  {
    title: "Microsoft Edge",
    icon: edge,
    url: "https://www.microsoft.com/en-US/windows/microsoft-edge"
  }
];

var b = DetectBrowser.detect();

var isWindows;

isWindows = b === null || b === undefined ? false : b.os.includes("Windows");

var browsersFiltered = browsers.filter(function (item) {
      if (isWindows) {
        return item.title !== "Apple Safari";
      } else {
        return item.title !== "Microsoft Edge";
      }
    });

function renderItem(b) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("a", {
                      children: JsxRuntime.jsx("img", {
                            className: "block w-[54px] h-[54px]",
                            title: b.title,
                            alt: b.title,
                            src: b.icon
                          }),
                      className: "block rounded-full p-[13px] bg-white",
                      href: b.url
                    }),
                JsxRuntime.jsx("a", {
                      children: b.title,
                      className: "block mt-4 text-lg font-light text-tan-blue-900 hover:no-underline",
                      href: b.url
                    })
              ],
              className: "flex flex-col items-center shrink-0 px-5 transition-transform duration-150 hover:scale-[1.15]"
            });
}

function GreatBrowsers(props) {
  var __title = props.title;
  var title = __title !== undefined ? __title : "Download the latest version of one of these great browsers to use TAN:";
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: title,
                      className: "text-zinc-800 text-[24px] leading-[1.5] text-center mb-[40px] font-light"
                    }),
                JsxRuntime.jsx("div", {
                      children: browsersFiltered.map(renderItem),
                      className: "flex justify-center items-center"
                    })
              ]
            });
}

var make = GreatBrowsers;

exports.Icons = Icons;
exports.DetectBrowser = DetectBrowser$1;
exports.browsers = browsers;
exports.isWindows = isWindows;
exports.browsersFiltered = browsersFiltered;
exports.renderItem = renderItem;
exports.make = make;
/* chrome Not a pure module */
